import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import * as artifactActions from '~/artifact/actions';
type ArtifactViewMainContentSignaturesComponentVersionsProps = {
  actions: object;
  artifactState: object;
};
class ArtifactViewMainContentSignaturesComponentVersions extends React.Component<
  ArtifactViewMainContentSignaturesComponentVersionsProps,
  {}
> {
  updateActiveVersion = e => {
    let version = e.target.value;
    this.props.actions.updateComponentVersion(version);
  };
  toggleVulnerableVersions = () => {
    let store = this.props.artifactState,
      displayOnlyVulnerableVersions = store.isDisplayVulnerableVersions,
      vulnerableVersionsByComponent = store.vulnerableVersionsByComponent,
      activeComponentId = store.componentId,
      vulnerableVersions = vulnerableVersionsByComponent[activeComponentId],
      vulnerableVersion =
        vulnerableVersions && vulnerableVersions[0] ? vulnerableVersions[0].version : null;
    if (!vulnerableVersions) {
      this.props.actions.fetchVulnerableComponentVersions(activeComponentId);
    }
    if (!displayOnlyVulnerableVersions) {
      // if we're moving to display only the vulnerable components, set the first one in that list as active
      this.props.actions.updateIsDisplayVulnerableVersions(!displayOnlyVulnerableVersions);
      this.props.actions.updateComponentVersion(vulnerableVersion);
    } else {
      this.props.actions.updateIsDisplayVulnerableVersions(!displayOnlyVulnerableVersions);
    }
  };
  render() {
    let store = this.props.artifactState,
      components = store.affectedComponents,
      vulnerableVersionsByComponent = store.vulnerableVersionsByComponent,
      activeComponentId = store.componentId,
      displayOnlyVulnerableVersions = store.isDisplayVulnerableVersions,
      activeVersion = store.componentVersion,
      activeComponent =
        _.find(components, function(component) {
          return component.id === activeComponentId;
        }) || {},
      activeVersions,
      versionOptions = [];
    if (displayOnlyVulnerableVersions) {
      activeVersions = vulnerableVersionsByComponent[activeComponentId] || [];
    } else {
      activeVersions = activeComponent.versions || [];
    }
    activeVersions.forEach(function(version, index) {
      versionOptions.push(
        <div
          key={`version-${version.version}-${index}`}
          className="grid__item col-1-1 phone--col-1-3"
        >
          <label className="label--radio">
            <input
              readOnly
              type="radio"
              name={version.version}
              value={version.version}
              checked={version.version === activeVersion}
            />
            <span className="react--radio" /> {version.version}
          </label>
        </div>
      );
    });
    return (
      <div className="grid grid--full col-1-1">
        <div className="grid__item col-3-4">
          <div className="font--h6 mb-">Library versions</div>
        </div>
        <div className="grid__item col-1-1">
          <label
            className="label--checkbox grid__item col-4-5 flex flex--justify-content--space-between flex--align-items--center bo-b--1 border-color--muted pb-"
            htmlFor="toggleVulnerableVersions"
            onChange={this.toggleVulnerableVersions}
          >
            Only vulnerable versions
            <input
              readOnly
              type="checkbox"
              id="toggleVulnerableVersions"
              checked={displayOnlyVulnerableVersions}
            />
            <span className="react--checkbox" />
          </label>
        </div>

        <div className="grid__item col-1-1 mt-">
          <form className="grid max-height--400" onChange={this.updateActiveVersion}>
            {versionOptions}
          </form>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    artifactState: state.artifactState,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(artifactActions, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ArtifactViewMainContentSignaturesComponentVersions);
